import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { LayoutDashboard, Settings2, Calculator, FileText, BookOpen, Settings, LogOut, Plus, Users, HelpCircle, Folder } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { useTranslation } from 'react-i18next';

export default function Sidebar({ isMobile = false, isOpen = false, onClose = () => {} }) {
  const { logout, language, setLanguage, user } = useApp();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const isPartner = user?.role === 'partner';
  const isAdmin = user?.role === 'admin';

  const items = [
    { to:'/dashboard',     icon: LayoutDashboard, label: t('nav.dashboard') },
    { to:'/capex',         icon: Settings2,       label: t('nav.capex') },
    { to:'/opex',          icon: Calculator,      label: t('nav.opex') },
    { to:'/business-plan', icon: FileText,        label: t('nav.bp'), disabled: true },
    { to:'/wiki',          icon: BookOpen,        label: t('nav.wiki') },
    ...(isPartner || isAdmin ? [
      { to:'/partner/clients', icon: Users,       label: t('nav.partnerClients') },
      { to:'/partner/faq',     icon: HelpCircle,  label: t('nav.partnerFaq') },
      { to:'/partner/content', icon: Folder,      label: t('nav.partnerContent') },
    ] : []),
    { to:'/settings',      icon: Settings,        label: t('nav.settings') },
    ...(isAdmin ? [{ to:'/admin', icon: LayoutDashboard, label: 'Admin' }] : []),
  ];

  return (
    <>
      {isMobile && isOpen && <button className="sidebar-overlay" onClick={onClose} aria-label="Close menu" />}
      <div className={`sidebar${isMobile ? ' sidebar-mobile' : ''}${isOpen ? ' open' : ''}`}>
        <div className="sidebar-brand" style={{ padding:'1.5rem 1.25rem 1rem', borderBottom:'1px solid rgba(40,65,154,0.1)' }}>
          <img src="/images/drones/logo.png" alt="FlyingBasket Logo" style={{ height:46, width:'auto', objectFit:'contain' }} />
        </div>

        <nav className="sidebar-nav" style={{ flex:1, paddingTop:'0.75rem' }}>
          {items.map(({to, icon:Icon, label, disabled}) => (
            disabled ? (
              <div key={to} className="nav-item nav-item-disabled" aria-disabled="true">
                <Icon size={18} />{label}
              </div>
            ) : (
              <NavLink key={to} to={to} onClick={onClose} className={({isActive}) => `nav-item${isActive?' active':''}`}>
                <Icon size={18} />{label}
              </NavLink>
            )
          ))}
        </nav>

        <div className="sidebar-footer" style={{ padding:'1rem 0.75rem' }}>
          <div className="language-switcher" style={{
            display:'flex', gap:'0.375rem', marginBottom:'0.75rem',
            background:'var(--surface-high)', borderRadius:'var(--radius)', padding:'0.25rem'
          }}>
            {[['en','🇬🇧 EN'],['it','🇮🇹 IT'],['fr','🇫🇷 FR'],['es','🇪🇸 ES'],['de','🇩🇪 DE']].map(([lang, label]) => (
              <button
                key={lang}
                onClick={() => setLanguage(lang)}
                style={{
                  flex:1, padding:'0.375rem', borderRadius:6, border:'none', cursor:'pointer',
                  fontSize:'0.75rem', fontWeight:700,
                  background: language === lang ? 'var(--primary)' : 'transparent',
                  color: language === lang ? 'white' : 'var(--on-surface-muted)',
                  transition:'all 0.15s'
                }}
              >
                {label}
              </button>
            ))}
          </div>

          <button className="btn-primary sidebar-cta" style={{ width:'100%', justifyContent:'center' }} onClick={() => { navigate('/opex'); onClose(); }}>
            <Plus size={16} /> {t('nav.newCalc')}
          </button>
          <button className="sidebar-logout" onClick={() => { logout(); onClose(); }} style={{ width:'100%', marginTop:'0.5rem', display:'flex', alignItems:'center', gap:'0.5rem', padding:'0.5rem 1rem', background:'none', border:'none', color:'var(--on-surface-muted)', cursor:'pointer', borderRadius:'var(--radius)', fontSize:'0.8rem' }}>
            <LogOut size={14} /> {t('nav.logout')}
          </button>
        </div>
      </div>
    </>
  );
}
